import { Outlet } from "react-router";

import { FullScreenLoader } from "@punto/ui/components/full-screen-loader";

import { useUser } from "@/modules/auth/hooks/use-user";
import { BulkActionsPanel, BulkActionsProvider } from "@/modules/bulk-actions";

import { Footer } from "./footer";
import { Header } from "./header";
import { ServiceBannerHost } from "./service-banner-host";

export const MainLayout = () => {
  const { isLoading } = useUser();

  // P-2226: hold the shell until /me settles. The abilities gates
  // (LandingRedirect / RequireSection / useBusinessAbilities) read an EMPTY
  // ability while /me is still in flight, so rendering them during that window
  // logs the user out (or hides nav) before their abilities arrive. `isLoading`
  // is false for the disabled, unauthenticated query, so this only blocks the
  // real authenticated load window — not the login flow or tests.
  if (isLoading) {
    return <FullScreenLoader data-testid="main-layout-loader" />;
  }

  return (
    <BulkActionsProvider>
      <div className="flex min-h-screen w-full flex-col bg-muted">
        <ServiceBannerHost />
        <Header />
        <Outlet />
        <Footer />
      </div>
      {/* Fixed bottom-right; outside the column so it never affects layout. */}
      <BulkActionsPanel />
    </BulkActionsProvider>
  );
};
